/* GTJ drawer controls - extracted from snippets/header-drawer.liquid (perf split 1 Sep 2026). */
  /* GTJ drawer controls (tabs, "+" accordions, Close, saved, cart).
     ALL handled in the CAPTURE phase with stopPropagation - Dawn's
     MenuDrawer binds a close handler to every <button> in the drawer
     (gotcha 17) and would otherwise close/ghost the drawer on any tap.
     Do not remove the `true` third argument. */
  (function () {
    /* perf split 1Sep2026: was document.currentScript.previousElementSibling (inline). */
    var root = document.querySelector('.section-header header-drawer') || document.querySelector('header-drawer');
    if (!root || root.tagName !== 'HEADER-DRAWER' || root.__gtjMd) return;
    root.__gtjMd = true;
    var gtjRestoreTimer = null;
    var gtjInPending = false;
    var details = root.querySelector('#Details-menu-drawer-container');
    var drawerEl = root.querySelector('#menu-drawer');
    /* CLEAN-FRAME GATE (30Jul stutter fix): every drawer toggle queues
       2-3 back-to-back ~60ms main-thread tasks (the html-class flips
       each cost a full-document style recalc - measured - plus
       analytics mutation processing). A `left` transition started
       inside that queue never paints its fast phase: browsers backdate
       the transition clock across a stall, so the first painted frame
       lands ~half way through the travel (the "minor stutter" -
       measured as a 212px leap). A FIXED defer (2 rAFs) was measured
       insufficient - the queue outlasts it. So: wait until TWO
       CONSECUTIVE rAFs arrive < 25ms apart (main thread provably
       drained), capped at 400ms so the menu always moves even under
       pathological jank, and only then start the slide. On a fast
       device the gate exits in ~2 frames = no perceptible delay. */
    /* ===== r55 FORCED-LAYOUT CACHE (perf round 3, 9Aug) =====
       Profiling a mobile menu tap (375px, 4x CPU throttle, third-party
       analytics blocked so the numbers are ours) showed ONE 1,614ms long
       task between tap and the panel appearing, with 623ms of it inside
       getBoundingClientRect. Cause: the open path reads layout AFTER it
       has already flipped classes on <html>/<body>, so each read forces a
       synchronous full-document layout - and it did several per tap
       (viewport width x8, ticker height, header height, root font size).
       None of these change between taps; they change on resize. So read
       them once, reuse, and re-measure on resize/load. Every call site
       still falls back to a live read if the cache was never primed, so
       behaviour is unchanged in every case. */
    function gtjMeasureChrome() {
      try {
        window.__gtjVW = window.innerWidth;
        window.__gtjRem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
        var t = document.querySelector('.gtj-ticker-section');
        var h = document.querySelector('.section-header');
        var p = 0;
        if (t && getComputedStyle(t).display !== 'none') p += t.getBoundingClientRect().height;
        if (h) p += h.getBoundingClientRect().height;
        window.__gtjPad = p;
      } catch (e) {}
    }
    window.gtjVW = function () {
      return window.__gtjVW || window.innerWidth;
    };
    window.gtjRem = function () {
      return window.__gtjRem || parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', gtjMeasureChrome);
    } else {
      gtjMeasureChrome();
    }
    window.addEventListener('load', gtjMeasureChrome, { once: true });
    window.addEventListener('resize', gtjMeasureChrome, { passive: true });

    function gtjCleanFrame(cb) {
      /* 8Aug FINAL (user compared against scuffers.com, whose menu
         starts moving on the very next frame after the tap): the gate
         is GONE - one rAF to align with the next frame, nothing else.
         History: 400ms calm-thread wait (round 2) -> 150 -> 60 -> 0.
         The stall-clamped animator below is the real protection: its
         clock advances at most 20ms per PAINTED frame, so starting on
         a busy thread yields brief slow-motion, never a leap. */
      requestAnimationFrame(function () { cb(); });
    }
    /* STALL-CLAMPED SLIDE ANIMATOR (30Jul round 2): the gate protects
       the slide START, but tasks can also land MID-slide (measured:
       Clarity's mutation batches from cycle N process during cycle
       N+1 - the user's "first time fine, second time glitches"). A CSS
       transition runs on a wall clock, so a mid-slide stall makes the
       browser backdate and the card teleports to catch up (reproduced
       with synthetic 60ms stalls: 112-152px leaps on some cycles).
       This animator advances its clock by AT MOST 20ms per painted
       frame regardless of real elapsed time: a stall becomes a brief
       imperceptible slow-motion, a leap is structurally impossible.
       Same curve/duration as the CSS rules, which remain as the no-JS
       fallback and as the settled-state authority (inline styles are
       removed once parked). Inline left is set with priority
       'important' - the only thing that beats the sheet's !important
       geometry rules. */
    var GTJ_EASE = (function () {
      /* cubic-bezier(0.22, 0.61, 0.36, 1) - identical to the CSS */
      function A(a1, a2) { return 1 - 3 * a2 + 3 * a1; }
      function B(a1, a2) { return 3 * a2 - 6 * a1; }
      function C(a1) { return 3 * a1; }
      function calc(t, a1, a2) { return ((A(a1, a2) * t + B(a1, a2)) * t + C(a1)) * t; }
      function slope(t, a1, a2) { return 3 * A(a1, a2) * t * t + 2 * B(a1, a2) * t + C(a1); }
      return function (x) {
        var t = x;
        for (var i = 0; i < 5; i++) {
          var s = slope(t, 0.22, 0.36);
          if (!s) break;
          t -= (calc(t, 0.22, 0.36) - x) / s;
        }
        return calc(t, 0.61, 1);
      };
    })();
    var gtjAnim = null;
    /* fromPx must be MEASURED BY THE CALLER BEFORE flipping any state
       class: reading the rect here, after the class flip, forces a
       layout that already resolves the NEW rule's left - from == to and
       the "slide" is a one-frame teleport (shipped + caught 30Jul). */
    function gtjAnimateLeft(el, fromPx, toPx, duration, done) {
      /* 9Aug DESKTOP: NO slide - surfaces appear in place (scuffers;
         user: "getting dragged to the right then fixes"). Zero style
         writes so the desktop CSS geometry is never fought; done runs
         next frame so every handover (glass/focus/teardown) still
         fires. Mobile keeps the slide below. */
      if (gtjVW() >= 990) {
        requestAnimationFrame(function () { if (done) done(); });
        return;
      }
      /* ROUND 37 FADE MODE: the cards are CSS-pinned at their final
         position and cross-fade (scuffers recipe - nothing moves, so
         the frost never strips). The animator's inline-important
         left/transition writes would defeat the CSS pins, so in fade
         mode it is a pure TIMER: same duration, same done callback
         (glass/focus/teardown choreography untouched), zero style
         writes. Set gtjFadeMode = false to restore the slide. */
      var gtjFadeMode = false; /* round 42: slide restored at user request */
      if (gtjFadeMode) {
        if (gtjAnim) { cancelAnimationFrame(gtjAnim.raf); gtjAnim = null; }
        el.style.removeProperty('left');
        el.style.removeProperty('transition');
        if (done) { if (duration) { setTimeout(done, duration); } else { done(); } }
        return;
      }
      if (gtjAnim) { cancelAnimationFrame(gtjAnim.raf); gtjAnim = null; }
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) duration = 0;
      /* r40 (user: menu lags while the page is still loading, fine
         after): during load the main thread belongs to parser +
         analytics long tasks and a JS-driven slide gets starved frame
         by frame - that starvation IS the lag. Until the load event
         fires, surfaces appear INSTANTLY (same policy as desktop);
         the smooth slide takes over automatically once loading ends. */
      if (document.readyState !== 'complete') duration = 0;
      el.style.setProperty('transition', 'none', 'important');
      if (!duration) {
        el.style.setProperty('left', toPx + 'px', 'important');
        if (done) done();
        return;
      }
      /* Pin the start position SYNCHRONOUSLY: the caller has just
         flipped a state class whose CSS rule computes the TARGET left;
         without this pin, the frame between the flip and the first rAF
         step renders the card AT the target, then step 1 yanks it back
         = a one-frame full-travel flash (caught by state sampling
         30Jul - only visible when frame timing aligns, which is why it
         showed "sometimes, not every cycle"). */
      el.style.setProperty('left', fromPx + 'px', 'important');
      var elapsed = 0, last = null, st = { raf: 0 };
      gtjAnim = st;
      function step(ts) {
        if (last !== null) elapsed += Math.min(ts - last, 20);
        last = ts;
        var p = Math.min(elapsed / duration, 1);
        el.style.setProperty('left', (fromPx + (toPx - fromPx) * GTJ_EASE(p)) + 'px', 'important');
        if (p < 1) { st.raf = requestAnimationFrame(step); }
        else { gtjAnim = null; if (done) done(); }
      }
      st.raf = requestAnimationFrame(step);
    }
    /* The slide-in is keyed on .gtj-md-in, added through the gate after
       Dawn's .menu-opening lands. The observer also lifts a
       still-running restore window on fast re-opens (the 900ms
       icon-freeze would otherwise fight the open), and drops
       .gtj-md-in whenever the menu stops opening so the next open
       starts parked (covers Esc/focusout closes that bypass
       closeDrawer). */
    if (details && drawerEl && window.MutationObserver) {
      var gtjWasOpen = details.hasAttribute('open');
      new MutationObserver(function () {
        /* r36 (user: mobile tap lags): Dawn adds .menu-opening in a
           setTimeout macrotask that queues BEHIND analytics/recalc
           tasks on a busy phone thread (the visible wait). The [open]
           attribute lands synchronously with the tap - promote the
           class ourselves in this observer microtask. One-shot on the
           closed->open edge only: during Dawn's close [open] outlives
           .menu-opening and a blind re-add would wedge the menu open. */
        var gtjIsOpen = details.hasAttribute('open');
        if (gtjIsOpen && !gtjWasOpen && gtjVW() < 990 && !details.classList.contains('menu-opening')) {
          details.classList.add('menu-opening');
        }
        gtjWasOpen = gtjIsOpen;
        if (details.classList.contains('menu-opening')) {
          clearTimeout(gtjRestoreTimer);
          document.documentElement.classList.remove('gtj-md-restore');
          if (!drawerEl.classList.contains('gtj-md-in') && !gtjInPending) {
            gtjInPending = true;
            gtjCleanFrame(function () {
              gtjInPending = false;
              if (details.classList.contains('menu-opening')) {
                /* measure the parked position BEFORE gtj-md-in flips
                   the target rule, then let JS drive the motion
                   (stall-clamped); on arrival the inline styles come
                   off and the .gtj-md-in CSS rule holds the open
                   position. */
                var fromPx = drawerEl.getBoundingClientRect().left;
                var rem = gtjRem();
                drawerEl.classList.add('gtj-md-in');
                gtjAnimateLeft(drawerEl, fromPx, 1.4 * rem, 300, function () {
                  drawerEl.style.removeProperty('left');
                  drawerEl.style.removeProperty('transition');
                  /* PARKED open: glass on (round 13) - only if the menu
                     is still actually open */
                  if (details.classList.contains('menu-opening')) {
                    drawerEl.classList.add('gtj-md-glass');
                  }
                });
              }
            });
          }
        } else {
          drawerEl.classList.remove('gtj-md-in');
          drawerEl.classList.remove('gtj-md-glass');
          /* Esc/focusout close while the open animation is mid-flight:
             kill the animator and its inline styles so Dawn's instant
             close isn't fought by a still-running slide-in. */
          if (gtjAnim && !drawerEl.classList.contains('gtj-md-closing')) {
            cancelAnimationFrame(gtjAnim.raf);
            gtjAnim = null;
            drawerEl.style.removeProperty('left');
            drawerEl.style.removeProperty('transition');
          }
        }
      }).observe(details, { attributes: true, attributeFilter: ['class', 'open'] });
    }
    function closeDrawer() {
      /* Slide the card out OURSELVES first (.gtj-md-closing), then hand
         over to Dawn's summary toggle for body classes / focus trap /
         teardown once the card is off-screen - Dawn's own timing races
         the transition and teleports the card otherwise.
         SPLIT ACROSS FRAMES (30Jul stutter fix): frame A does the
         expensive html.gtj-md-restore flip (~60ms recalc, measured) +
         instant Close-row feedback while the card is still stationary;
         the slide class lands two rAFs later on a clean main thread so
         every frame of the fast phase paints (was: 2-3 poses + leap). */
      if (!details || !details.hasAttribute('open')) return;
      var summary = details.querySelector('summary');
      if (drawerEl && details.classList.contains('menu-opening')) {
        if (drawerEl.classList.contains('gtj-md-closing') || drawerEl.classList.contains('gtj-md-pre')) return;
        /* frame A: tap feedback (Close row hides via .gtj-md-pre, cheap
           scoped rule) + the heavy restore flip. ORDER MATTERS:
           gtj-md-restore now, so by frame B the real icon has long been
           un-scaled to its natural 20px when the decoy clones its rect
           (round 7o). */
        /* glass OFF first (round 13): the slide must run on a
           filter-free card - decoy anchoring + iOS compositing */
        drawerEl.classList.remove('gtj-md-glass');
        drawerEl.classList.add('gtj-md-pre');
        document.documentElement.classList.add('gtj-md-restore');
        /* keep the restore overrides (hamburger icon forced, no fades)
           until Dawn's 400ms rAF teardown has removed [open].
           DEDUPED: a stale timer from a previous close firing mid-cycle
           un-froze the icon every other close (the alternating bug).
           Armed here as a safety net for the gate-bail path, RE-armed
           at slide start below so its 900ms always covers the full
           330ms slide + Dawn's ~400ms teardown even if the gate waited. */
        clearTimeout(gtjRestoreTimer);
        gtjRestoreTimer = setTimeout(function () {
          document.documentElement.classList.remove('gtj-md-restore');
          /* round 45: the freeze (keyed on gtj-md-restore) lifts here -
             one clean on-image evaluation with the settled layout */
          if (window.gtjRemeasure) window.gtjRemeasure();
        }, 900);
        gtjCleanFrame(function () {
          /* frame B: the recalc queue has drained; start the slide on a
             clean main thread so every frame of the fast phase paints. */
          drawerEl.classList.remove('gtj-md-pre');
          if (!details.hasAttribute('open') || !details.classList.contains('menu-opening')) return;
          var decoy = drawerEl.querySelector('.gtj-md__burger-decoy');
          var realIcon = summary && summary.querySelector('.icon-hamburger');
          if (decoy && realIcon) {
            var iRect = realIcon.getBoundingClientRect();
            decoy.style.top = iRect.top + 'px';
            decoy.style.left = iRect.left + 'px';
            decoy.style.width = iRect.width + 'px';
            decoy.style.height = iRect.height + 'px';
          }
          /* measure the open position BEFORE gtj-md-closing flips the
             target rule (see gtjAnimateLeft note), then JS drives the
             slide-out too (stall-clamped, no mid-flight leaps); the
             .gtj-md-closing CSS stays as no-JS fallback. */
          var closeFromPx = drawerEl.getBoundingClientRect().left;
          drawerEl.classList.remove('gtj-md-in');
          drawerEl.classList.add('gtj-md-closing');
          gtjAnimateLeft(drawerEl, closeFromPx, -gtjVW(), 300, null);
          clearTimeout(gtjRestoreTimer);
          gtjRestoreTimer = setTimeout(function () {
            document.documentElement.classList.remove('gtj-md-restore');
            /* round 45: freeze lifts - clean re-evaluation (fixes the
               black-then-white flash over banners on menu close) */
            if (window.gtjRemeasure) window.gtjRemeasure();
          }, 900);
          setTimeout(function () {
            drawerEl.classList.remove('gtj-md-closing');
            /* card is parked - drop the animator's inline styles so the
               sheet rules (base park, hidden) govern the closed state */
            drawerEl.style.removeProperty('left');
            drawerEl.style.removeProperty('transition');
            /* Dawn's teardown focuses the summary, which some
               environments (Chrome device-mode touch emulation) answer
               by scrolling it into view = page yanked to top. Pin the
               scroll position across the handover. */
            var y = window.scrollY;
            if (summary) summary.click();
            try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
            requestAnimationFrame(function () {
              try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
            });
            /* 9Aug desktop: Dawn removes [open] on a transitionend that
               never fires here (no slide) - force the teardown so the
               close is INSTANT */
            if (gtjVW() >= 990) {
              setTimeout(function () {
                var d = document.getElementById('Details-menu-drawer-container');
                if (d && d.hasAttribute('open')) d.removeAttribute('open');
                document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile', 'overflow-hidden');
              }, 40);
            }
          }, gtjVW() >= 990 || document.readyState !== 'complete' ? 0 : 330);
        });
      } else if (summary) {
        summary.click();
      }
    }
    /* r33 (speed): closing via the burger went through Dawn's
       closeMenuDrawer, which holds [open] ~400ms waiting on a
       transitionend that never fires on desktop (no slide). Intercept
       the toggle-click in capture and tear down instantly - same moves
       as the X-button fast path. Desktop only; mobile keeps its slide. */
    document.addEventListener('click', function (e) {
      if (gtjVW() < 990) return;
      var s = e.target.closest('#Details-menu-drawer-container > summary');
      if (!s) return;
      var d = document.getElementById('Details-menu-drawer-container');
      if (!d || !d.hasAttribute('open')) return;
      e.preventDefault();
      e.stopPropagation();
      var y = window.scrollY;
      d.removeAttribute('open');
      d.classList.remove('menu-opening');
      document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile', 'overflow-hidden');
      try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (err) { window.scrollTo(0, y); }
    }, true);
    root.addEventListener('click', function (e) {
      /* OPEN tap: measure the header group's REAL flow height before
         Dawn's lock pulls it out of the document, and publish it as
         --gtj-lock-pad so main can refund exactly that much (round
         13c). Must run before the lock; no stopPropagation - Dawn
         still needs this click to open the menu. */
      if (details && !details.hasAttribute('open') && e.target.closest('summary')) {
        /* r55: was two getBoundingClientRect + a getComputedStyle taken
           right here on every tap = a forced full-document layout in the
           critical path. Same numbers, measured off the critical path
           (see gtjMeasureChrome); live read only if never primed. */
        var pad = window.__gtjPad;
        if (pad == null) {
          pad = 0;
          var tks = document.querySelector('.gtj-ticker-section');
          var shs = document.querySelector('.section-header');
          if (tks && getComputedStyle(tks).display !== 'none') pad += tks.getBoundingClientRect().height;
          if (shs) pad += shs.getBoundingClientRect().height;
        }
        if (pad > 0) document.documentElement.style.setProperty('--gtj-lock-pad', pad + 'px');
        /* 8Aug: sync the drawer's cart dot with the LIVE cart at every
           open (quick-adds change the count without a reload; Dawn
           re-renders the bar bubble, whose id survives only on the real
           bar - the search-head clone's ids are stripped). */
        var mdDot = document.querySelector('.gtj-md__cart-dot');
        if (mdDot) mdDot.hidden = !document.querySelector('#cart-icon-bubble .cart-count-bubble');
      }
      var tab = e.target.closest('.gtj-md__tab');
      if (tab) {
        e.stopPropagation();
        var key = tab.getAttribute('data-gtj-tab');
        root.querySelectorAll('.gtj-md__tab').forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        root.querySelectorAll('.gtj-md__panel').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-gtj-panel') === key);
        });
        return;
      }
      var btn = e.target.closest('.gtj-md__acc-btn');
      if (btn) {
        e.stopPropagation();
        e.preventDefault();
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var acc = btn.closest('.gtj-md__acc');
        var panel = acc ? acc.querySelector('.gtj-md__acc-panel') : btn.nextElementSibling;
        if (panel) panel.hidden = open;
        return;
      }
      var cls = e.target.closest('[data-gtj-close]');
      if (cls) {
        e.stopPropagation();
        closeDrawer();
        return;
      }
      var saved = e.target.closest('[data-gtj-open-saved]');
      if (saved) {
        e.stopPropagation();
        e.preventDefault();
        closeDrawer();
        /* open the header Saved panel once the slide-out is done */
        setTimeout(function () {
          var b = document.querySelector('.gtj-header-bm') || document.querySelector('button[aria-label="Saved items"]');
          if (b) b.click();
        }, 400);
        return;
      }
      var cart = e.target.closest('[data-gtj-open-cart]');
      if (cart) {
        e.stopPropagation();
        e.preventDefault();
        closeDrawer();
        setTimeout(function () {
          var c = document.getElementById('cart-icon-bubble');
          if (c) c.click();
          else window.location.href = cart.getAttribute('href') || '/cart';
        }, 400);
        return;
      }
    }, true);
    /* 5Aug below-bar sheet: the bar summary (burger/X) is VISIBLE and
       tappable while the drawer is open now - a raw tap would run
       Dawn's instant toggle and teleport the card mid-slide. Capture
       it and route through the choreographed close instead. */
    document.addEventListener('click', function (e) {
      /* programmatic clicks (closeDrawer's own Dawn hand-over) must
         pass through untouched - intercept REAL taps only */
      if (!e.isTrusted) return;
      if (!details || !details.hasAttribute('open')) return;
      var sum = e.target.closest('header-drawer > details > summary');
      if (!sum || sum !== details.querySelector('summary')) return;
      if (drawerEl && (drawerEl.classList.contains('gtj-md-closing') || drawerEl.classList.contains('gtj-md-pre'))) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
    }, true);
    /* ===== SEARCH TAKEOVER wiring (round 15) =====
       Dawn owns the search modal markup, so rather than forking
       sections/header.liquid the extras block (rendered just before
       <header-drawer>) is MOVED into .search-modal__content on first
       open. Also: publishes --gtj-search-top so the sheet starts at the
       nav card's bottom edge in every state, mirrors the open state as
       html.gtj-search-open (the ÃƒÆ’Ã‚Â¢Ãƒâ€¹Ã…â€œÃƒâ€šÃ‚Â° hides, Dawn's X takes its slot -
       :has() would work but the standing rule is to pair it with a
       JS-set class), and hides the extras while a query is typed so
       Dawn's predictive results own the panel. */
    (function () {
      /* DOM-READY GATE: this snippet renders BEFORE Dawn's
         .header__search (verified: "search AFTER drawer"), so querying
         at parse time found nothing and the whole wiring silently
         no-oped. */
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', gtjInitSearch);
      } else {
        gtjInitSearch();
      }
      function gtjInitSearch() {
      var sd = document.querySelector('.header__search details');
      var extras = document.querySelector('.gtj-search-extras');
      if (!sd) return;
      var input = sd.querySelector('input[name="q"]');
      if (input) input.setAttribute('placeholder', 'Find your style...');
      function syncTyping() {
        if (extras && input) extras.classList.toggle('is-typing', input.value.trim().length > 0);
      }
      /* DOM surgery moved from first-open to INIT (3Aug, "it lagged"):
         relocating the extras + promoting Dawn's close button used to
         happen in the same breath as the open tap - now the panel is
         fully assembled before anyone touches the magnifier. (Round 17
         context: the close button must be the card's first child so it
         forms the fixed head; the capture-phase close handler treats
         .search-modal__close-button as a close target.) */
      (function assembleOnce() {
        var host = sd.querySelector('.search-modal__content');
        if (extras && host && extras.parentElement !== host) {
          host.appendChild(extras);
          extras.hidden = false;
        }
        /* direct query - modalEl() is assigned further down and this
           runs immediately at init */
        /* 5Aug (user): the card head is now a BAR-LIKE ROW - small X +
           magnifier on the left, cloned save (bookmark) + cart icons on
           the right - instead of the lone X. Clones are visual + basic
           navigation only (ids stripped so the originals keep theirs);
           the magnifier re-focuses the input. */
        /* 5Aug (user): the card head is a BAR-LIKE ROW - small X +
           magnifier on the left, cloned save (bookmark) + cart icons on
           the right. Clones are visual + basic navigation only (ids
           stripped); the magnifier re-focuses the input. */
        var card = sd.querySelector('.search-modal');
        var cb = sd.querySelector('.search-modal__close-button');
        if (card && cb && !card.querySelector('.gtj-search-head')) {
          var head = document.createElement('div');
          head.className = 'gtj-search-head';
          card.insertBefore(head, card.firstChild);
          head.appendChild(cb);
          /* 8Aug X-consistency: swap Dawn's fill-drawn icon-close for the
             SITE X (same 1.2-stroke line glyph the menu drawer + saved
             panel use) - button + its handlers untouched */
          cb.innerHTML = '<svg width="16" height="16" viewBox="0 0 15 15" fill="none" aria-hidden="true" focusable="false"><path d="M1.5 1.5L13.5 13.5M13.5 1.5L1.5 13.5" stroke="currentColor" stroke-width="1.2"/></svg>';
          var magSrc = document.querySelector('.header__search summary svg.modal__toggle-open') ||
                       document.querySelector('.header__search summary .modal__toggle-open svg');
          if (magSrc) {
            var mag = document.createElement('button');
            mag.type = 'button';
            mag.className = 'gtj-search-head__mag';
            mag.setAttribute('aria-label', 'Search');
            mag.appendChild(magSrc.cloneNode(true));
            mag.addEventListener('click', function () {
              var inp2 = sd.querySelector('input[name="q"]');
              if (inp2) inp2.focus();
            });
            head.appendChild(mag);
          }
          var right = document.createElement('div');
          right.className = 'gtj-search-head__right';
          var stripIds = function (el) {
            el.removeAttribute('id');
            el.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
            return el;
          };
          var bmSrc = document.querySelector('.section-header .gtj-header-bm');
          if (bmSrc) right.appendChild(stripIds(bmSrc.cloneNode(true)));
          var cartSrc = document.querySelector('.section-header .header__icon--cart');
          if (cartSrc) right.appendChild(stripIds(cartSrc.cloneNode(true)));
          if (right.children.length) head.appendChild(right);
        }
      })();
      function onOpen() {
        /* 5Aug scroll-drag fix: publish the header group's flow height
           as --gtj-lock-pad (same measurement as the drawer's open tap)
           so the overflow-hidden refund above is exact. Heights are
           still measurable after the pin - fixed boxes keep their
           rects. */
        var padTks = document.querySelector('.gtj-ticker-section');
        var padShs = document.querySelector('.section-header');
        var padSum = 0;
        if (padTks && getComputedStyle(padTks).display !== 'none') padSum += padTks.getBoundingClientRect().height;
        if (padShs) padSum += padShs.getBoundingClientRect().height;
        if (padSum > 0) document.documentElement.style.setProperty('--gtj-lock-pad', padSum + 'px');
        /* KEYBOARD vs SLIDE (3Aug): Dawn autofocuses the input on open,
           so the iOS keyboard animated up WHILE the card slid in - two
           heavy animations at once = the lag. Blur immediately; the
           slide-done callback refocuses once the card is parked. (If
           iOS declines the late programmatic focus, the user taps the
           field - smoothness wins over auto-keyboard.) */
        var inp = sd.querySelector('input[name="q"]');
        if (inp) inp.blur();
        syncTyping();
      }
      /* ===== DRAWER MECHANICS FOR THE SEARCH CARD (round 16) =====
         Reuses the drawer's gtjCleanFrame + gtjAnimateLeft (this block
         lives inside the drawer's closure on purpose): slide starts
         only on a provably clean frame, its clock is stall-clamped so
         a mid-slide task can't make it leap, and the glass lands only
         once the card is parked. */
      var modalEl = function () { return sd.querySelector('.search-modal'); };
      var searchClosing = false;
      function slideSearchIn() {
        var m = modalEl();
        if (!m) return;
        m.classList.remove('gtj-search-glass');
        m.style.removeProperty('left');
        gtjCleanFrame(function () {
          if (!sd.hasAttribute('open')) return;
          var from = m.getBoundingClientRect().left;
          var rem = gtjRem();
          m.classList.add('gtj-search-in');
          gtjAnimateLeft(m, from, 1.4 * rem, 300, function () {
            m.style.removeProperty('left');
            m.style.removeProperty('transition');
            if (sd.hasAttribute('open')) {
              m.classList.add('gtj-search-glass');
              /* keyboard AFTER the card parks (3Aug lag fix) */
              var inp = sd.querySelector('input[name="q"]');
              if (inp) inp.focus({ preventScroll: true });
            }
          });
        });
      }
      function resetSearchCard() {
        var m = modalEl();
        if (!m) return;
        m.classList.remove('gtj-search-in');
        m.classList.remove('gtj-search-glass');
        m.style.removeProperty('left');
        m.style.removeProperty('transition');
      }
      /* CLOSE: our slide runs FIRST, Dawn's teardown only after the
         card is off-screen (racing Dawn teleports it - the drawer's
         round-7e lesson). Capture phase so Dawn's own summary handler
         never sees the tap. */
      document.addEventListener('click', function (e) {
        if (!sd.hasAttribute('open') || searchClosing) return;
        if (!e.target.closest(
          '.header__search summary, .search-modal__close-button, .header__search .modal-overlay')) return;
        e.preventDefault();
        e.stopPropagation();
        searchClosing = true;
        /* ROUND 45: freeze on-image evaluation for the whole close
           window - transient teardown layout was flapping the bar's
           state (the scrolled-close stutter); one clean re-evaluation
           runs at the end via gtjRemeasure. */
        window.gtjFreezeOnImg = true;
        var m = modalEl();
        var dm = document.querySelector('details-modal.header__search');
        if (!m) { if (dm && dm.close) dm.close(); window.gtjFreezeOnImg = false; searchClosing = false; return; }
        /* ROUND 40 (user: "lag + the icon goes small then normal on
           close"): release the bar's search-open state IMMEDIATELY
           instead of at the +330ms teardown - the X->magnifier swap and
           the summary's return to its slot now happen at close frame A,
           under the fading card, not as a late visible pop. Safe since
           round 31: the bar carries no backdrop-filter, so the
           containing-block trap this delay guarded can't re-arm. The
           [open]-observer re-syncs the class at teardown (no-op). */
        /* 5Aug (user: "icons disappear for a moment on close"): frame-A
           release flipped the bar to its on-image WHITE icons while the
           WHITE card still covered it for the 330ms slide - white on
           white read as vanished. gtj-search-closing HOLDS the
           search-open look (solid white bar, black icons) until the
           card is fully off-screen, then the bar flips to its settled
           state in one atomic swap. */
        document.documentElement.classList.add('gtj-search-closing');
        document.documentElement.classList.remove('gtj-search-open');
        m.classList.remove('gtj-search-glass');
        var from = m.getBoundingClientRect().left;
        m.classList.remove('gtj-search-in');
        gtjAnimateLeft(m, from, -gtjVW(), 300, function () {
          document.documentElement.classList.remove('gtj-search-closing');
        });
        setTimeout(function () {
          /* ROUND 41 (user: "closing the search bar drags it to the top
             of the screen"): Dawn's teardown focus-restore scrolls the
             page to the top (measured scrollY 601 -> 0). Pin the scroll
             across the close and re-pin next frame. */
          var gtjSy = window.scrollY || document.documentElement.scrollTop || 0;
          /* safety net - the slide callback normally clears this at
             +300ms; never let it outlive the close */
          document.documentElement.classList.remove('gtj-search-closing');
          resetSearchCard();
          if (dm && typeof dm.close === 'function') dm.close();
          else sd.removeAttribute('open');
          window.scrollTo(0, gtjSy);
          requestAnimationFrame(function () {
            window.scrollTo(0, gtjSy);
            /* ROUND 44/45: teardown + the scroll pin shift layout after
               gtj-scroll-state's ranges were measured - unfreeze, then
               one clean re-measure with the settled layout. */
            window.gtjFreezeOnImg = false;
            if (window.gtjRemeasure) window.gtjRemeasure();
          });
          searchClosing = false;
        }, gtjVW() >= 990 || document.readyState !== 'complete' ? 0 : 330);
      }, true);
      if (window.MutationObserver) {
        new MutationObserver(function () {
          var open = sd.hasAttribute('open');
          document.documentElement.classList.toggle('gtj-search-open', open);
          if (open) { window.gtjFreezeOnImg = false; onOpen(); slideSearchIn(); }
          else {
            document.documentElement.classList.remove('gtj-search-closing');
            resetSearchCard(); /* Esc / programmatic close */
            /* round 45: Esc-path closes bypass the handler - make sure
               the freeze never sticks and the state re-evaluates */
            window.gtjFreezeOnImg = false;
            if (window.gtjRemeasure) window.gtjRemeasure();
          }
        }).observe(sd, { attributes: true, attributeFilter: ['open'] });
      }
      if (input) input.addEventListener('input', syncTyping);
      }
    })();
    /* Keep the "Most Wanted" superscript honest when gtj-journey swaps
       in personalized chips (may be 3-6 items instead of 6) */
    var chipsWrap = root.querySelector('[data-gtj-menu-chips]');
    var supCount = root.querySelector('.gtj-md__wanted-title sup');
    if (chipsWrap && supCount && window.MutationObserver) {
      new MutationObserver(function () {
        supCount.textContent = String(chipsWrap.querySelectorAll('.gtj-md__chip').length);
      }).observe(chipsWrap, { childList: true });
    }
    /* 8Aug (scuffers-parity, first-tap lag): the FIRST open used to pay
       the drawer card's first-ever raster (tabs, chips, tiles, fonts)
       INSIDE the tap - the second open was always snappier. Warm it at
       idle instead: two frames in-viewport but invisible (opacity 0,
       inert), so layout + paint happen once before the user ever taps.
       Inline props are set 'important' (the parked geometry rules are
       !important) and fully removed after. Skips if already open. */
    (function gtjWarmDrawer() {
      var warmed = false;
      var WARM_PROPS = ['transition', 'opacity', 'pointer-events', 'visibility', 'position', 'left', 'top'];
      function unwarm(md) {
        for (var i = 0; i < WARM_PROPS.length; i++) md.style.removeProperty(WARM_PROPS[i]);
      }
      function warm() {
        if (warmed) return;
        warmed = true;
        var md = document.querySelector('.menu-drawer');
        var det = document.querySelector('header-drawer details');
        if (!md || (det && det.hasAttribute('open'))) return;
        try {
          md.style.setProperty('transition', 'none', 'important');
          md.style.setProperty('opacity', '0', 'important');
          md.style.setProperty('pointer-events', 'none', 'important');
          md.style.setProperty('visibility', 'visible', 'important');
          md.style.setProperty('position', 'fixed', 'important');
          md.style.setProperty('left', '0', 'important');
          md.style.setProperty('top', '0', 'important');
          void md.offsetWidth;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { unwarm(md); });
          });
        } catch (e) { unwarm(md); }
      }
      function sched() {
        setTimeout(function () {
          if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 1500 });
          else setTimeout(warm, 500);
        }, 300);
      }
      /* 8Aug r2 (user: the lag happens WHILE the page is still loading,
         gone once load completes): warm at DOM-READY, not window.load -
         load waits for every image, which is exactly the window the
         user taps in. DCL + 300ms + idle callback keeps it out of the
         critical parse path while landing well before load. */
      if (document.readyState !== 'loading') sched();
      else document.addEventListener('DOMContentLoaded', sched);
    })();
  })();
